import { getEmptyProductConfiguration } from '@/utils/emptyProduct';
import type { IProduct } from '@/typescript/interfaces/IProduct';
import type { IProductDTO } from '@/typescript/interfaces/IProductDTO';

function productToDTO(product: IProduct): IProductDTO {
    return {
        id: product.id,
        prestashopUserId: product.prestashopUserId,
        thumbnail: product.thumbnailUrl,
        name: product.name,
        projectJson: JSON.stringify({ ...product.configuration, poleBAT: undefined, poleImgRender: undefined }),
        prestashopSessionToken: product.prestashopSessionToken,
    };
}

function DTOToProduct(dto: IProductDTO): IProduct {
    const configuration = JSON.parse(dto.projectJson);
    return {
        id: dto.id,
        prestashopUserId: dto.prestashopUserId,
        thumbnailUrl: dto.thumbnail,
        name: dto.name,
        configuration: Array.isArray(configuration) ? getEmptyProductConfiguration() : JSON.parse(dto.projectJson),
    };
}

export { productToDTO, DTOToProduct };
